import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

const inputData = defineMessages({
  account_number_au: {
    id: 'shared_components.input_data.account_number_au_placeholder',
    defaultMessage: 'Bank Account Number'
  },
  bsb_number: {
    id: 'shared_components.input_data.bsb_number_placeholder',
    defaultMessage: 'BSB Number'
  },
  email: {
    id: 'shared_components.input_data.personal_email_placeholder',
    defaultMessage: 'Email'
  },
  iban_number: {
    id: 'shared_components.input_data.iban_number_placeholder',
    defaultMessage: 'IBAN'
  },
  job_title: {
    id: 'shared_components.input_data.job_title_placeholder',
    defaultMessage: 'Job Title'
  },
  login_pw: {
    id: 'shared_components.input_data.password_placeholder',
    defaultMessage: 'Password'
  },
  signup_pw: {
    id: 'shared_components.input_data.signup_password_placeholder',
    defaultMessage: 'Password'
  },
  organization: {
    id: 'shared_components.input_data.organization_placeholder',
    defaultMessage: 'Organization'
  },
  personal_message: {
    id: 'shared_components.input_data.personal_message_placeholder',
    defaultMessage: 'Check out the spaces I found on Peerspace and let me know what you think.'
  },
});

export const InputData = {
  default_input: {
    values: {
      type: 'text'
    },
    error: {}
  },
  default_input_number: {
    values: {
      type: 'number'
    },
    error: {}
  },
  default_textarea: {
    values: {
      type: 'textarea'
    },
    error: {}
  },
  default_checkbox: { // Checkbox
    values: {
      type: 'checkbox'
    },
    error: {}
  },
  terms_of_service: {
    values: {
      placeholder: '',
      type: 'checkbox',
      label: <p className="col-xs-11">I have read and agree to the <a href="/legal/terms">Peerspace Terms and Conditions</a>, as well as the <a href="//stripe.com/us/connect-account/legal">Stripe Connected Account Agreement</a> from our payments provider.</p>
    }
  },
  email: {
    values: {
      id: 'email-input',
      label: <FormattedMessage id="shared_components.input_data.email_label" defaultMessage="Email" />,
      placeholder: inputData.email,
      type: 'email'
    },
    error: {}
  },
  login_pw: {
    values: {
      id: 'login-pw-input',
      label: <FormattedMessage id="shared_components.input_data.password_label" defaultMessage="Password" />,
      placeholder: inputData.login_pw,
      type: 'password'
    },
    error: {}
  },
  password: {
    values: {
      id: 'password-input',
      label: 'Password',
      placeholder: inputData.signup_pw,
      type: 'password'
    },
    error: {}
  },
  first_name: {
    values: {
      id: 'first-name-input',
      placeholder: 'First Name',
      type: 'text'
    },
    error: {}
  },
  last_name: {
    values: {
      id: 'last-name-input',
      placeholder: 'Last Name',
      type: 'text'
    },
    error: {}
  },
  address1: {
    values: {
      id: 'address1',
      label: 'Street Address',
      placeholder: '',
      type: 'text'
    },
    error: {}
  },
  address2: {
    values: {
      id: 'address2',
      label: 'Apartment or Unit',
      placeholder: '',
      type: 'text'
    },
    error: {}
  },
  city: {
    values: {
      id: 'city',
      label: 'City',
      placeholder: '',
      type: 'text'
    },
    error: {}
  },
  state: {
    values: {
      id: 'state',
      label: 'State',
      type: 'select',
      optional: false
    },
    error: {}
  },
  zipcode: {
    values: {
      id: 'zipcode-input',
      label: 'Zip code',
      placeholder: 'Zip / Postal code',
      type: 'text'
    },
    error: {}
  },
  organization: {
    values: {
      id: 'organization-input',
      placeholder: inputData.organization,
      type: 'text'
    },
    error: {}
  },
  job_title: {
    values: {
      id: 'job-title-input',
      placeholder: inputData.job_title,
      type: 'text'
    },
    error: {}
  },
  mobile_phone: {
    values: {
      helper_text: <FormattedMessage id="shared_components.input_data.use_phone_number" defaultMessage="We will only use your phone number for booking updates." />,
      id: 'mobile-phone-input',
      placeholder: 'Mobile Phone',
      type: 'text'
    },
    error: {}
  },
  verification_code: {
    values: {
      id: 'verification-code-input',
      placeholder: 'XXXX',
      type: 'number'
    },
    error: {}
  },
  attendees: {
    values: {
      id: 'attendees-input',
      type: 'number'
    },
    error: {}
  },
  required_textbox_response: {
    values: {
      id: 'required-response',
      type: 'textarea'
    },
    error: {}
  },
  review_response: {
    values: {
      id: 'review-response',
      type: 'textarea',
      maxLength: '1500'
    },
    error: {}
  },
  msg_host: { // Text Area
    values: {
      id: 'msg-host-textarea',
      label: 'Text area',
      placeholder: 'Tell the host about your activity and mention any extras you might need, like catering or chairs.',
      type: 'textarea'
    },
    error: {}
  },
  flex_time: { // Checkbox
    values: {
      id: 'flex-time',
      label: <FormattedMessage id="shared_components.input_data.flex_time_label" defaultMessage="My dates / times are flexible" />,
      placeholder: '',
      type: 'checkbox'
    },
    error: {}
  },
  cardholders_name: { // Text
    values: {
      id: 'cardholders-name',
      label: 'Cardholder\'s Name',
      placeholder: 'Cardholder\'s Name',
      type: 'text'
    },
    error: {}
  },
  cardnumber: {
    values: {
      id: 'cardnumber',
      label: 'Card Number',
      placeholder: 'Card Number',
      type: 'tel'
    },
    error: {}
  },
  month: {
    values: {
      id: 'month',
      label: 'month',
      placeholder: 'MM'
    },
    error: {}
  },
  year: {
    values: {
      id: 'year',
      label: 'year',
      placeholder: 'YYYY'
    },
    error: {}
  },
  day: {
    values: {
      id: 'day',
      label: 'day',
      placeholder: 'DD'
    },
    error: {}
  },
  cvv: {
    values: {
      id: 'cvv',
      label: 'cvv',
      placeholder: 'CVV'
    },
    error: {}
  },
  account_holder: {
    values: {
      type: 'text'
    },
    error: {}
  },
  csrf_token_input: {
    values: {
      type: 'hidden'
    },
    error: {}
  },
  hidden_account_type: {
    values: {
      type: 'hidden'
    },
    error: {}
  },
  hidden_country_code: {
    values: {
      type: 'hidden'
    },
    error: {}
  },
  hidden_currency_code: {
    values: {
      type: 'hidden'
    },
    error: {}
  },
  hidden_routing_number: {
    values: {
      type: 'hidden'
    },
    error: {}
  },
  account_number: {
    values: {
      label: 'Bank Account Number',
      maxLength: '17'
    },
    error: {}
  },
  routing_number: {
    values: {
      label: 'Routing Number',
      maxLength: '9'
    },
    error: {}
  },
  account_number_ca: {
    values: {
      label: 'Bank Account Number',
      maxLength: '12'
    },
    error: {}
  },
  transit_number: {
    values: {
      label: 'Transit Number',
      maxLength: '5'
    },
    error: {}
  },
  institution_number: {
    values: {
      label: 'Institution Number',
      maxLength: '3'
    },
    error: {}
  },
  sort_code: {
    values: {
      label: 'Sort Code Number',
      maxLength: '6'
    },
    error: {}
  },
  account_number_uk: {
    values: {
      label: 'Account Number',
      maxLength: '8'
    },
    error: {}
  },

  tax_id: {
    values: {
      id: 'tax_id',
      type: 'text'
    },
    error: {}
  },
  business_name: {
    values: {
      id: 'business_name',
      placeholder: 'Business Name'
    },
    error: {}
  },
  last_4: {
    values: {
      id: 'last-4',
      placeholder: 'XXXX',
      type: 'text'
    },
    error: {}
  },
  activity: {
    values: {
      id: 'activity',
      placeholder: 'Activity',
      type: 'text'
    },
    error: {}
  },
  activity_date: {
    values: {
      id: 'activity_date',
      placeholder: 'Activity Date',
      type: 'text'
    },
    error: {}
  },
  location: {
    values: {
      id: 'location',
      placeholder: 'Location',
      type: 'text'
    },
    error: {}
  },
  board_name: {
    values: {
      id: 'board_name',
      placeholder: 'Board Name',
      type: 'text'
    },
    error: {}
  },
  board_description: {
    values: {
      id: 'board_description',
      placeholder: 'Add a description to your board',
      type: 'textarea'
    },
    error: {}
  },
  meta_email: {
    values: {
      id: 'meta-email',
      label: 'Invite by email',
      placeholder: 'Enter emails separated by commas.',
      type: 'textarea'
    },
    error: {}
  },
  personal_message: {
    values: {
      id: 'personal-message',
      label: <FormattedMessage id="shared_components.input_data.personal_message_label" defaultMessage="Include a personal message" />,
      placeholder: inputData.personal_message,
      type: 'textarea'
    },
    error: {}
  },
  concierge_budget: {
    values: {
      id: 'concierge-budget',
      label: '2. My budget for these services is...',
      placeholder: '',
      type: 'text'
    },
    error: {}
  },
  other_concierge_items: {
    values: {
      id: 'other-concierge-items',
      label: '',
      placeholder: 'Enter the service that specifically need',
      type: 'textarea'
    },
    error: {}
  },
  concierge_details: {
    values: {
      type: 'textarea'
    },
    error: {}
  },
  comment: { // Text Area
    values: {
      id: 'comment',
      label: 'Text area',
      placeholder: 'Add a comment',
      type: 'textarea'
    },
    error: {}
  },
  other_how_did_you_hear: {
    values: {
      id: 'other-how-did-you-hear',
      label: '',
      placeholder: '',
      type: 'text'
    },
    error: {}
  },
  block_day_title: {
    values: {
      id: 'block-day-title',
      placeholder: '',
      type: 'text'
    },
    error: {}
  },
  all_day: { // Checkbox
    values: {
      id: 'all-day',
      label: <FormattedMessage id="shared_components.input_data.all_day_label" defaultMessage="All day" />,
      placeholder: '',
      type: 'checkbox'
    },
    error: {}
  },
  iban_number: {
    values: {
      id: 'iban-number-input',
      label: <FormattedMessage id="shared_components.input_data.iban_number_label" defaultMessage="IBAN" />,
      placeholder: inputData.iban_number,
      maxLength: '34'
    },
    error: {}
  },
  bsb_number: {
    values: {
      id: 'bsb-number-input',
      label: <FormattedMessage id="shared_components.input_data.bsb_number_label" defaultMessage="BSB Number" />,
      placeholder: inputData.bsb_number,
      maxLength: '6'
    },
    error: {}
  },
  account_number_au: {
    values: {
      id: 'account-number-au-input',
      label: <FormattedMessage id="shared_components.input_data.account_number_au_label" defaultMessage="Bank Account Number" />,
      placeholder: inputData.account_number_au,
      maxLength: '9'
    },
    error: {}
  },
  custom_offer_subtotal: {
    values: {
      id: 'custom-offer-subtotal-input',
      type: 'number'
    },
    error: {}
  }
};
